export const experienceTitle = "Experience";

export const experienceData = [
  {
    key: 2,
    importance: 1,
    date: "March 2025 - present",
    title: "Senior Blockchain Engineer",
    establishment: {
      name: "Impossible Cloud Network",
      url: "https://www.icn.global/",
      location: "Hamburg, Germany (Remote)",
    },
    details: [
      "Designed and implemented production Solidity smart contracts for provider registration, payments, and reward distribution using a modular, upgradeable Diamond architecture.",
      "Implemented on-chain tokenomics supporting approximately $1.5M in monthly reward distributions.",
      "Owned the smart contract security lifecycle, including threat modeling, audit preparation, vulnerability remediation, and resolution of 15+ post-launch bug bounty reports.",
      "Built migration scripts and deployment tooling for contract upgrades and protocol state transitions.",
      "Automated governance and maintenance workflows using Safe Multisig and the Safe SDK.",
      "Built CI/CD pipelines for automated smart contract testing and deployment.",
      "Deployed OpenZeppelin Monitor on Kubernetes to watch on-chain events and alert on failures via Slack/email.",
      "Authored NatSpec documentation, architecture diagrams, and technical specifications for engineering and audit teams.",
    ],
    info: "DePIN protocol for decentralized cloud storage. Designed and implemented the smart contracts covering provider registration, payments, and rewards. Responsible for testing, maintenance, upgrades, and bug bounty responses.",
    skills: [
      "Solidity",
      "Foundry",
      "OpenZeppelin",
      "EVM",
      "TypeScript",
      "Node.js",
      "Safe",
      "Kubernetes",
      "CI/CD",
      "DePIN",
      "DeFi",
    ],
    image: "",
    links: [{ name: "", url: "" }],
  },
  {
    key: 1,
    importance: 2,
    date: "September 2021 - July 2025",
    title: "Blockchain Engineer",
    establishment: { name: "Ideasoft", url: "https://ideasoft.io/", location: "Kiev, Ukraine (Remote)" },
    details: [
      "Build Solidity contracts for DeFi and NFT applications on EVM chains",
      "Reduce gas costs through storage packing, inline assembly, and efficient data structures",
      "Write thorough test suites — unit, fuzz, and invariant — before anything goes to mainnet",
      "Build TypeScript/JavaScript scripts to call contract functions and automate on-chain operations",
      "Maintain NatSpec, architecture docs, and technical specs for auditors and the team",
    ],
    info: "Contracted through Ideasoft as a blockchain engineer for multiple Web3 clients — building DeFi protocols, cross-chain bridges, and on-chain derivatives. Delivered smart contract systems for Kadena's cross-chain bridge, JibX's perpetual DEX, Dollet Wallet's yield strategies, and DEIN's insurance protocol.",
    skills: [
      "DeFi",
      "NFT",
      "Solidity",
      "Hardhat",
      "Foundry",
      "OpenZeppelin",
      "Web3.js",
      "Ethers.js",
      "EVM chain",
      "Oracle",
      "JavaScript",
      "TypeScript",
      "Node.js",
    ],
    image: "",
    links: [{ name: "", url: "" }],
  },
];
